import NavigationMobileHeader from '@/components/common/menu/NavigationMobileHeader.tsx'
import NavigationDesktopLayer from '@/components/common/menu/NavigationDesktopLayer.tsx'
import NavSkeleton from '@/routes/settings/settingsRoot/loading/navSkeleton.tsx'
import { Suspense } from 'react'
import useNavData from '@/components/common/menu/lib/hooks/useNavData.tsx'

export default function Navigation() {
  const { primaryMenuData, secondaryMenuData } = useNavData()

  return (
    <Suspense fallback={<NavSkeleton />}>
      {/* MOBILE — just the contextual topbar. The main menu is now rendered
          as a floating bottom sheet by BottomTabBar (BottomTabBarMoreSheet),
          so the old right-anchored NavigationMobileLayer is no longer
          mounted. The sheet consumes the same primaryMenuData/secondaryMenu
          pairing internally via useNavData. */}
      <nav className={`md:hidden`}>
        <NavigationMobileHeader menuState={`closedMobile`} />
      </nav>

      {/* DESKTOP MENU */}
      <nav className="fixed top-0 hidden h-svh w-[var(--sidebar-width)] flex-col border-r bg-prologisAccent md:flex">
        <NavigationDesktopLayer menuLayer={`primaryDesktop`} navigationData={primaryMenuData} />
        {secondaryMenuData && (
          <NavigationDesktopLayer
            menuLayer={`secondaryDesktop`}
            navigationData={secondaryMenuData}
          />
        )}
      </nav>
    </Suspense>
  )
}
